/**
 * Intl Plural Rules Polyfill for IE11 & Safari 12-
 *
 * @src       https://github.com/formatjs/react-intl/blob/master/docs/Getting-Started.md#runtime-requirements
 * @author    Ryan Hibbert <rhibbert@wayfair.com>
 * @copyright 2020 Wayfair LLC - All rights reserved
 */

require('@formatjs/intl-pluralrules/polyfill');
require('@formatjs/intl-pluralrules/dist/locale-data/en');
require('@formatjs/intl-pluralrules/dist/locale-data/pl');
require('@formatjs/intl-pluralrules/dist/locale-data/de');
require('@formatjs/intl-pluralrules/dist/locale-data/fr');
